"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FINGERPRINT = exports.Action = exports.Result = exports.AvroOptional = void 0;
exports.log = log;
const signals_logger_1 = require("@indeed/signals-logger");
const Result_1 = require("./Result");
Object.defineProperty(exports, "Result", { enumerable: true, get: function () { return Result_1.Result; } });
const Action_1 = require("./Action");
Object.defineProperty(exports, "Action", { enumerable: true, get: function () { return Action_1.Action; } });
var signals_logger_2 = require("@indeed/signals-logger");
Object.defineProperty(exports, "AvroOptional", { enumerable: true, get: function () { return signals_logger_2.AvroOptional; } });
exports.FINGERPRINT = "b6c327c5c156c4bb";
function log(message) {
    (0, signals_logger_1.log)(exports.FINGERPRINT, message);
}
